import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faHandHoldingDollar, faArrowUpRightFromSquare, faCircleNotch, faLock, faCircleInfo, faPlusCircle, faChartSimple, faCircleCheck, faCircleDown, faClock, faTriangleExclamation, faUser, faCreditCard, faCircleUp, faUsd, faCoins, faUpload, faSackDollar } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import { useNavigate, useLocation, Link } from 'react-router-dom'
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { GaugeComponent } from 'react-gauge-component';

function Loandetails() {
  const { user } = useUser();
  const [loading, setLoading] = useState(true);
  const { state } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const lsType = localStorage.getItem('deposit.loanID');
    const hasType = state?.loan_id || lsType;
    if (!hasType) {
      navigate('/getLoan', { replace: true });
    } else {
      setLoading(false);
    }
  }, [state, navigate]);
  const [loan_id, setLoan_id] = useState(() => {return state?.loan_id ?? localStorage.getItem('deposit.loanID');});
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
    const r = await getRate(currencyCode);
    if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);

  const getCreditColor = (score) => {
    if (score >= 800) return { color: "#00FF15", label: "Excellent" };
    if (score >= 780) return { color: "#95ff87ff", label: "Very Good" };
    if (score >= 741) return { color: "#ffc107", label: "Good" };
    if (score >= 600) return { color: "#fd7e14", label: "Fair" };
    return { color: "#FF2121", label: "Poor" };
    };
  const creditInfo = getCreditColor(user?.credit_score || 0);

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Get a Loan" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Get a Loan" icon={<FontAwesomeIcon icon={faHandHoldingDollar} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="mb-4 mt-3">
                <h5 className="mb-0" style={{fontWeight:'900',lineHeight:'120%'}}>Loan Application</h5>
                <p className="mb-0" style={{fontSize:'14px'}}><Link to="/loan" className="noLink text-prime fw-semibold">Loan</Link> <FontAwesomeIcon icon={faAngleRight} style={{fontSize: '12px'}} /> Qualification Method</p>
            </div>
            <p className="mb-0 text-center" style={{fontWeight:'900',fontSize:'18px'}}>Choose Qualification Method</p>
            <p className="mb-0 text-center" style={{fontSize:'14px'}}>If your credit score is low, you can qualify using your equity lock instead.</p>
            <div>
              <div className="row">
                <div className="col-md-6 g-4">
                  <div className="mycard shadow p-3">
                    <div className="d-flex align-items-start justify-content-between" style={{opacity: Number(user?.credit_score) > 740 ? '1' : '0.2'}}>
                      <div>
                        <p className="mb-2 fw-bold text-uppercase" style={{fontSize:'14px'}}>Current Score</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>Credit Score as at October 20, 2025</p>
                      </div>
                      <div className="myBtn px-2 py-1 fw-semibold lh-1 rounded-3" style={{fontSize:'12px'}}>Live</div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8 offset-lg-2">
                        <div className="position-relative mx-auto" style={{maxWidth:'400px',width:'100%'}} style={{opacity: Number(user?.credit_score) > 740 ? '1' : '0.2'}}>
                          <GaugeComponent
                            type="semicircle"
                            minValue={300}
                            maxValue={850}
                            arc={{
                              colorArray: ['#FF2121', '#00FF15'],
                              padding: 0,
                              subArcs: [
                                { limit: 400 },
                                { limit: 500 },
                                { limit: 600 },
                                { limit: 700 },
                                { limit: 750 },
                                { limit: 800 },
                                { limit: 850 }
                              ]
                            }}
                            pointer={{ type: "blob", animationDelay: 1 }}
                            value={Number(user?.credit_score)}
                          />
                          <p className="mb-0 position-absolute fw-semibold text-uppercase fw-bold" style={{bottom:'10%',color: creditInfo.color, transform: 'translateX(-50%)',left:'50%'}}>{creditInfo.label}</p>
                        </div>
                      </div>
                      <p className="mb-0" style={{fontSize:'12px'}}>Projection (with actions below)</p>
                      <p className="mb-3 fw-bold" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faChartSimple} className="text-success me-1"/> +60–110 pts in 90–180 days</p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <Link to="/improvescore" className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'12px', minWidth:'45%'}}>Improve Credit Score <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></Link>
                      { Number(user?.credit_score) > 740 ?
                        (
                          <Link to="/loanform" state={{loan_id: loan_id,casset: 'Bitcoin', collateral: 0, collat : 'BTC'}} className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'12px', minWidth:'45%'}}>Continue <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></Link>
                        ) : (  
                          <div className="myBtn rounded-pill px-3 py-2 fw-semibold text-center disabled" style={{fontSize:'12px', minWidth:'45%'}}>Continue <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{fontSize: '10px'}} /></div>
                        )
                      }
                    </div>
                  </div>
                  <div className="mycard mt-2">
                    <p className="mb-2 fw-bold text-uppercase" style={{fontSize:'14px'}}>HOW TO IMPROVE YOUR CREDIT SCORE</p>
                    <p className="mb-0" style={{fontSize:'14px'}}><b>A stronger credit score</b> helps you qualify for better rates, higher limits, and faster approvals. Follow these proven steps to build consistent, positive history.</p>
                    <div className="row">
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faCircleCheck} style={{fontSize: '20px'}} className="text-success"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Pay bills on time</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faCircleDown} style={{fontSize: '20px'}} className="text-warning"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Keep credit utilization low</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faClock} style={{fontSize: '20px'}} className="text-info"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Don’t close old accounts</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faTriangleExclamation} style={{fontSize: '18px'}} className="text-danger"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Dispute credit report errors</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faUser} style={{fontSize: '18px'}} className="text-info"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Become an authorized user</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '18px'}} className="text-white"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Use secured credit cards</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faCircleUp} style={{fontSize: '20px'}} className="text-success"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Use credit builder loans</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 g-4">
                  <div className="mycard p-3">
                    <div className="p-2 rounded-3 fw-semibold" style={{fontSize:'14px',backgroundColor:'#ff212117',color:'#ff2121'}}>Your Credit Score Is Below the Required Threshold (740)</div>
                    <p className="mb-0 mt-2" style={{fontSize:'14px'}}>You can still qualify using your Equity Lock — a secure way to back your loan with collateral instead of relying on credit score.</p>
                    <div className="d-flex align-items-center mt-3">
                      <div className="d-flex align-items-center justify-content-center mycard" style={{width:'50px',height:'50px',backgroundColor:'#ff6b351c'}}>
                        <p className="fw-bold fs-4 mb-0 text-prime"><FontAwesomeIcon icon={faLock} style={{fontSize: '20px'}} className="lh-1" /></p>
                      </div>
                      <div className="ms-2">
                        <p className="mb-0 fw-semibold lh-1" style={{fontSize:'14px'}}>Equity Lock 
                          <FontAwesomeIcon
                            icon={faCircleInfo}
                            title="Your Equity Lock represents funds set aside as collateral. It helps you qualify by showing financial backing."
                            className="ms-2 text-secondary"
                            style={{ cursor: 'pointer', fontSize: '12px' }}
                          />
                        </p>
                        <p className="mb-0 fs-4" style={{fontWeight:'900',lineHeight:'120%'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.equity)}</p>
                      </div>
                    </div>
                    <div className="mt-2">
                      <p className="text-secondary mb-2" style={{ fontSize: '14px' }}>
                        Your Equity Lock represents funds set aside as collateral. It helps you qualify by showing financial backing — the more you lock, the better your access to premium loan offers and terms.
                      </p>
                      <div className="rounded-pill mb-2" style={{ height: '8px', backgroundColor:'#e9e9e925' }}>
                        <div className="h-100"
                          style={{
                            width: `${Math.min((user?.equity / user?.maxequity) * 100, 100)}%`,
                            backgroundColor: '#ff6b35'
                          }} aria-valuenow={user?.equity} aria-valuemin="0" aria-valuemax={user?.maxequity}
                        ></div>
                      </div>
                      <p className="mb-3" style={{fontSize:'12px'}}>
                        You’re {Math.round(Math.min((user?.equity / user?.maxequity) * 100, 100))}% toward the recommended equity level for full loan eligibility.
                      </p>
                      <div className="d-flex align-items-center justify-content-end">
                        <Link to="/deposit" state={{route: 'equity'}} className="myBtn rounded-pill px-3 py-2 fw-semibold text-center" style={{fontSize:'14px', minWidth:'45%'}}><FontAwesomeIcon icon={faPlusCircle} style={{fontSize: '12px'}} className="me-2" /> Proceed to Equity</Link>
                      </div>
                    </div>
                  </div>
                  <div className="mycard p-3 mt-2">
                    <p className="mb-0" style={{fontWeight:'900'}}>WHAT IS EQUITY LOCK</p>
                    <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Your Equity Lock is the amount of funds or assets you secure as collateral.
                      It allows you to qualify for loans without depending on your credit score. By locking a specific value, you demonstrate financial assurance and gain access to better loan offers.</p>
                  </div>
                  <div className="mycard p-3 mt-2">
                    <p className="mb-0" style={{fontWeight:'900'}}>WHY EQUITY LOCK</p>
                    <p className="mb-1 text-secondary" style={{fontSize:'14px'}}>Equity Lock provides an alternative path to loan approval when your credit score is below the required threshold.</p>
                    <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>It shows lenders that you have financial backing, helping you:</p>
                    <ul className="text-secondary" style={{fontSize:'14px'}}>
                      <li>Qualify for higher loan amounts</li>
                      <li>Access lower interest rates</li>
                      <li>Build a strong trust profile with lenders</li>
                    </ul>
                  </div>
                  <div className="mycard mt-2">
                    <p className="mb-2 fw-bold text-uppercase" style={{fontSize:'14px'}}>HOW TO USE EQUITY LOCK</p>
                    <p className="mb-0" style={{fontSize:'14px'}}>Follow these simple steps to activate your Equity Lock and proceed with your loan:</p>
                    <div className="row">
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faCoins} style={{fontSize: '20px'}} className="text-success"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Select Collateral Asset</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faUsd} style={{fontSize: '20px'}} className="text-warning"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Input Amount</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faCreditCard} style={{fontSize: '20px'}} className="text-info"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Proceed with Payment</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faUpload} style={{fontSize: '18px'}} className="text-danger"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Upload Payment Proof</p>
                        </div>
                      </div>
                      <div className="col-md-4 g-3">
                        <div className="rounded-4 d-flex align-items-center mycard p-3" style={{gap:'15px'}}>
                          <div className="rounded-circle bg-black d-flex align-items-center justify-content-center" style={{height:'40px',width:'40px',minHeight:'40px',minWidth:'40px'}}>
                            <FontAwesomeIcon icon={faSackDollar} style={{fontSize: '18px'}} className="text-info"/>
                          </div>
                          <p className="mb-0 fw-semibold" style={{fontSize:'14px'}}>Proceed to Get Loan</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Loandetails